import { create } from 'zustand';
import { getErrorMessage } from '@/shared/lib/errors';
import type { AppChatService, AppChatRouteData, AppChatRouteActions } from './types';

/** Хранит разрешение прежней ссылки с защитой от смены владельца */
export const createAppChatRouteStore = (service: AppChatService) => {
    let revision = 0;

    return create<AppChatRouteData & AppChatRouteActions>((set) => ({
        error: null,

        resolve: async (legacyId, companionId, canCreate = false) => {
            const current = ++revision;
            set({ error: null });
            try {
                if (!legacyId && !companionId) return null;

                const dialog = legacyId
                    ? await service.resolve(legacyId)
                    : canCreate
                        ? await service.getOrCreate(companionId ?? '')
                        : (await service.findByCompanion(companionId ?? '')).items?.[0];

                if (!dialog?.id) throw new Error('Переписка не найдена или недоступна');

                return current === revision
                    ? dialog.id ?? null
                    : null;
            } catch (error: unknown) {
                if (current === revision) set({ error: getErrorMessage(error, 'Переписка по ссылке недоступна') });
                return null;
            }
        },

        reset: () => {
            revision += 1;
            set({ error: null });
        },
    }));
};
